import { Link } from 'react-router-dom';

export function HomePage() {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2.5rem 2rem' }}>
      <h1 style={{ fontWeight: 800, fontSize: '2rem', marginBottom: '0.4rem' }}>Dance Transcription</h1>
      <p style={{ color: '#64748b', marginTop: 0, marginBottom: '2rem', fontSize: '1.05rem' }}>
        Create and browse contra dance transcriptions
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.25rem' }}>
        <Link to="/generate" className="home-card" style={{ '--card-accent': '#f59e0b' } as React.CSSProperties}>
          <h2>Generate Dance</h2>
          <p>Use AI to create a new dance based on your prompt</p>
        </Link>

        <Link to="/upload" className="home-card" style={{ '--card-accent': '#0891b2' } as React.CSSProperties}>
          <h2>Upload Dance</h2>
          <p>Manually add a dance transcription</p>
        </Link>

        <Link to="/browse" className="home-card" style={{ '--card-accent': '#10b981' } as React.CSSProperties}>
          <h2>Browse Dances</h2>
          <p>View all dance transcriptions</p>
        </Link>

        <Link to="/programs" className="home-card" style={{ '--card-accent': '#7c3aed' } as React.CSSProperties}>
          <h2>Browse Programs</h2>
          <p>View and manage your evening programs</p>
        </Link>

        <Link to="/programs/generate" className="home-card" style={{ '--card-accent': '#db2777' } as React.CSSProperties}>
          <h2>Generate Program</h2>
          <p>Tell AI your goals and it'll build an evening set list</p>
        </Link>

        <Link to="/programs/new" className="home-card" style={{ '--card-accent': '#e85d04' } as React.CSSProperties}>
          <h2>Build Program</h2>
          <p>Manually assemble a set list from your library</p>
        </Link>
      </div>
    </div>
  );
}
